(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-article-intro"] && !Shopify.designMode) return;
  try {
    
(()=>{const build=()=>{const toc=document.querySelector('.jj-toc'),list=toc?.querySelector('[data-jj-toc-list]'),content=document.querySelector('.article-template__content');if(!toc||!list||!content)return;const hs=[...content.querySelectorAll('h2,h3')].filter(h=>h.textContent.trim());if(hs.length<2)return;const used=new Set();hs.forEach((h,i)=>{let slug=h.id||h.textContent.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');if(!slug)slug=`abschnitt-${i+1}`;const base=slug;let n=2;while(used.has(slug)){slug=`${base}-${n++}`}used.add(slug);h.id=slug;const li=document.createElement('li');if(h.tagName==='H3')li.classList.add('jj-toc__subitem');const a=document.createElement('a');a.href=`#${slug}`;a.textContent=h.textContent.trim();li.appendChild(a);list.appendChild(li)});toc.hidden=false};document.readyState==='loading'?document.addEventListener('DOMContentLoaded',build,{once:true}):build()})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-mobile-buy-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeBar = (bar) => {
      if (!bar || bar.dataset.initialized === 'true') return;
      bar.dataset.initialized = 'true';

      const stickyButton = bar.querySelector('[data-jj-mobile-buy-action]');
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      let originalButton = null;
      let originalObserver = null;
      let priceObserver = null;
      let stateObserver = null;
      let isOriginalVisible = false;
      let isPricePassed = false;

      const findOriginalButton = () =>
        document.querySelector('product-form .product-form__submit[name="add"]');

      const findPriceAnchor = () =>
        document.querySelector('[id^="price-"]') || document.querySelector('.product__title');

      const syncButtonState = () => {
        originalButton = findOriginalButton();
        if (!originalButton || !stickyButton) return;

        stickyButton.disabled = originalButton.disabled;
        const originalText = originalButton.querySelector('span')?.textContent?.trim();
        if (originalText) {
          stickyButton.textContent = originalText;
          stickyButton.setAttribute('aria-label', `${originalText}: ${bar.dataset.productTitle || ''}`.trim());
        }
      };

      const setVisible = () => {
        const shouldShow = Boolean(
          isPricePassed &&
          !isOriginalVisible &&
          mobileQuery.matches &&
          originalButton &&
          !originalButton.disabled
        );
        bar.classList.toggle('is-visible', shouldShow);
        bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };

      const connect = () => {
        originalObserver?.disconnect();
        priceObserver?.disconnect();
        stateObserver?.disconnect();
        isOriginalVisible = false;
        isPricePassed = false;

        originalButton = findOriginalButton();
        const priceAnchor = findPriceAnchor();
        syncButtonState();
        setVisible();
        if (!originalButton) return;

        originalObserver = new IntersectionObserver(
          ([entry]) => {
            isOriginalVisible = Boolean(entry?.isIntersecting);
            setVisible();
          },
          { root: null, threshold: [0, 1] }
        );
        originalObserver.observe(originalButton);

        if (priceAnchor) {
          priceObserver = new IntersectionObserver(
            ([entry]) => {
              isPricePassed = Boolean(
                entry &&
                !entry.isIntersecting &&
                entry.boundingClientRect.bottom < 0
              );
              setVisible();
            },
            { root: null, threshold: [0, 1] }
          );
          priceObserver.observe(priceAnchor);
        }

        stateObserver = new MutationObserver(() => {
          syncButtonState();
          setVisible();
        });
        stateObserver.observe(originalButton, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true
        });
      };

      stickyButton?.addEventListener('click', () => {
        const target = findOriginalButton();
        if (target && !target.disabled) target.click();
      });

      mobileQuery.addEventListener?.('change', setVisible);
      connect();
    };

    const initializeWithin = (root) => {
      if (root.matches?.('[data-jj-mobile-buy-bar]')) initializeBar(root);
      root.querySelectorAll?.('[data-jj-mobile-buy-bar]').forEach(initializeBar);
    };

    initializeWithin(document);
    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-purchase-options"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jj-routine-builder')) {
    customElements.define(
      'jj-routine-builder',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';
          this.inputs = Array.from(this.querySelectorAll('input[type="checkbox"][data-price]'));
          this.summary = this.querySelector('[data-summary]');
          this.addButton = this.querySelector('[data-add]');
          this.error = this.querySelector('[data-error]');
          this.inputs.forEach((input) => input.addEventListener('change', () => this.update()));
          this.addButton?.addEventListener('click', () => this.addSelected());
          this.update();
        }

        selected() {
          return this.inputs.filter((input) => input.checked && !input.disabled);
        }

        update() {
          const selected = this.selected();
          const count = selected.length;
          const subtotal = selected.reduce((sum, input) => sum + Number.parseInt(input.dataset.price, 10), 0);

          if (count === 0) {
            this.summary.textContent = this.dataset.summaryEmpty;
          } else {
            this.summary.textContent = this.dataset.summarySelected
              .replace('[count]', String(count))
              .replace('[price]', this.formatMoney(subtotal));
          }

          if (this.addButton) this.addButton.disabled = count === 0 || this.dataset.ready !== 'true';
        }

        formatMoney(cents) {
          return new Intl.NumberFormat(this.dataset.locale || 'de-DE', {
            style: 'currency',
            currency: this.dataset.currency || 'EUR'
          }).format(cents / 100);
        }

        async addSelected() {
          const selected = this.selected();
          if (!selected.length || this.dataset.ready !== 'true') return;

          this.addButton.disabled = true;
          this.addButton.textContent = this.dataset.loading;
          this.error.hidden = true;

          try {
            const response = await fetch(this.dataset.cartAddUrl, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: selected.map((input) => ({ id: Number.parseInt(input.value, 10), quantity: 1 })),
                sections: ['cart-drawer', 'cart-icon-bubble'],
                sections_url: window.location.pathname
              })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || this.dataset.error);

            const drawer = document.querySelector('cart-drawer');
            if (drawer?.renderContents) {
              drawer.renderContents(result);
              this.inputs.forEach((input) => {
                input.checked = false;
              });
              this.update();
            } else {
              window.location.assign(this.dataset.cartUrl);
            }
          } catch (error) {
            this.error.textContent = error.message || this.dataset.error;
            this.error.hidden = false;
          } finally {
            this.addButton.textContent = this.dataset.add;
            this.update();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
